import o from "./ghl-ui.es1448.js";
import t from "./ghl-ui.es1449.js";
import a from "./ghl-ui.es1450.js";
import r from "./ghl-ui.es1451.js";
import m from "./ghl-ui.es1452.js";
var e = {
  code: "fi",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const s = e;
export {
  s as default
};
